<div class="controls-container">
  <div role="group" class="panel-body-row">
    <label for="change-audio-input" translate>Audio Input</label>
    <select
      name="mic"
      [disabled]="isAudioDisabled"
      [(ngModel)]="audioDeviceId"
      (ngModelChange)="deviceChange('audioinput', $event)"
      id="change-audio-input"
      data-tid="device-settings/change-audio-input"
    >
      @for (device of audioMediaDevices; track trackByFn($index, device)) {
      <option [value]="device.deviceId">
        {{ device.label }}
      </option>
      }
    </select>
  </div>

  @if (videoMediaDevices.length > 0) {
  <div role="group" class="panel-body-row">
    <label for="change-video-input" translate>Camera Input</label>
    <select
      name="cam"
      [disabled]="!camOn"
      [(ngModel)]="videoDeviceId"
      (ngModelChange)="deviceChange('videoinput', $event)"
      id="change-video-input"
      data-tid="device-settings/change-video-input"
    >
      @for (device of videoMediaDevices; track trackByFn($index, device)) {
      <option [value]="device.deviceId">
        {{ device.label }}
      </option>
      }
    </select>
  </div>
  } @if (isSpeakerSupported) {
  <div role="group" class="panel-body-row">
    <label for="change-audio-output" translate>Audio Output</label>
    <select
      name="speaker"
      [disabled]="isSpeakerDisabled"
      [(ngModel)]="speakerDeviceId"
      (ngModelChange)="deviceChange('audiooutput', $event)"
      id="change-audio-output"
      data-tid="device-settings/change-audio-output"
    >
      @for (device of speakerMediaDevices; track trackByFn($index, device)) {
      <option [value]="device.deviceId">
        {{ device.label }}
      </option>
      }
    </select>
  </div>
  }
</div>
